import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import "./MyWallet.css";
import BackArrowIcon from "../../Asserts/images/back_arrow.svg";

import useDeviceType from "../../Utiles/FindDevice";
import { fetchRoundPageCategory } from "./roundToJoin.slice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MyTransactions from "./MyTransaction";
import MyWinnings from "./MyWinnings";
import Withdraw from "./Withdraw";
import TokenTransfer from "./TokenTransfer";
import MyInvoice from "./MyInvoice";
import Navbar from "../RoundToJoin/navbar";
import Footer from "../../Components/Footer";

export default function MyWallet() {
  const token = localStorage.getItem("access_token");
  const location = useLocation();
  const { myRound } = location.state || {};
  const pageCategory = useSelector((state) => {
    return state.roundToJoin.pageCategory;
  });
  const [dateRange, setDateRange] = useState([null, null]);

  const [dateInvoiceRange, setInvoiceDateRange] = useState([null, null]);

  const deviceType = useDeviceType();
  const [showWithdraw, setShowWithdraw] = useState(false);

  const handleWithdrawClick = () => {
    setShowWithdraw(true);
  };

  // States for navigation and UI
  const [selectedNav, setSelectedNav] = useState("My Wallet");
  const [selectedSubNav, setSelectedSubNav] = useState("My Transactions");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [totalWinnings, setTotalWinnings] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profileBtnRef = useRef(null);
  const datePickerRef = useRef(null);

  useEffect(() => {
    if (dropdownOpen && profileBtnRef.current) {
      const rect = profileBtnRef.current.getBoundingClientRect();
      setDropdownPos({ right: 0 });
    }
  }, [dropdownOpen]);

  const renderSelectedComponent = () => {
    switch (selectedSubNav) {
      case "My Transactions":
        return {
          MainComponent: <MyTransactions dateRange={dateRange} />,
          title: selectedSubNav,
          component: (
            <div className="gap-2 relative mobile-daterange-wrapper">
              <span className="text-xs sm:text-sm text-gray-500 font-medium font-archivo whitespace-nowrap">
                FILTER BY DATE
              </span>
              <div
                className="min-w-0 flex-1 sm:flex-none mobile-daterange-container"
                ref={datePickerRef}
              >
                <DateRangePicker
                  onChange={setDateRange}
                  value={dateRange}
                  className="custom-daterange-picker mobile-daterange-picker"
                  calendarClassName="react-daterange-picker__calendar mobile-calendar-dropdown"
                  rangeDivider="–"
                  format="dd/MM/yyyy"
                  clearIcon={null}
                  calendarProps={{
                    locale: "en-US",
                    showWeekNumbers: false,
                    calendarType: "gregory",
                    showDoubleView: false,
                  }}
                  calendarIcon={
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                        clipRule="evenodd"
                      />
                    </svg>
                  }
                />
              </div>
            </div>
          ),
        };
      case "My Winnings":
        return {
          MainComponent: <MyWinnings setTotalWinnings={setTotalWinnings} />,
          title: selectedSubNav,
          component: (
            <div className="flex justify-between items-center flex-wrap gap-4">
              <div className="text-black text-[10px] md:text-sm font-medium order-first md:order-none rounded-md border border-gray-200 p-0.5 md:p-1">
                Total winnings till now: ${" "}
                {totalWinnings?.total_winnings_amount}
              </div>
            </div>
          ),
        };
      case "Withdraw":
        return {
          MainComponent: <Withdraw showWithdraw={showWithdraw} />,
          title: showWithdraw ? (
            <div className="flex items-center  gap-2">
              <img
                src={BackArrowIcon}
                alt="Back"
                className="w-6 h-6 cursor-pointer"
                onClick={() => setShowWithdraw(false)}
              />
              <p className="font-archivo font-medium text-[22px]">
                {`${selectedSubNav}`}
              </p>
            </div>
          ) : (
            `${selectedSubNav} History`
          ),
          component: !showWithdraw && (
            <div className="flex justify-start items-center gap-4">
              <button
                className="bg-[#007FFF] text-white px-1.5 py-1 md:px-4 md:py-2 rounded-md font-semibold text-[12px] md:text-sm flex items-center justify-center gap-2"
                onClick={handleWithdrawClick}
              >
                Withdraw Amount
              </button>
            </div>
          ),
        };
      case "Token Transfer":
        return { MainComponent: <TokenTransfer />, component: null };
      case "My Invoice":
        return {
          MainComponent: <MyInvoice dateRange={dateInvoiceRange} />,
          title: selectedSubNav,
          component: (
            <div className="gap-2 relative mobile-daterange-wrapper">
              <span className="text-xs sm:text-sm text-gray-500 font-medium font-archivo whitespace-nowrap">
                FILTER BY DATE
              </span>
              {/* <div className="mb-4 mt-2">
                <div
                  className="min-w-0 flex-1 sm:flex-none mobile-daterange-container"
                  ref={datePickerRef}
                >
                  <DateRangePicker
                    onChange={{ setDateRange }}
                    value={dateRange}
                    className="custom-daterange-picker mobile-daterange-picker"
                    calendarClassName="react-daterange-picker__calendar mobile-calendar-dropdown"
                    rangeDivider="–"
                    format="dd/MM/yyyy"
                    clearIcon={null}
                    calendarIcon={
                      <svg
                        className="w-4 h-4 text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    }
                  />
                </div>
              </div> */}
              <div
                className="min-w-0 flex-1 sm:flex-none mobile-daterange-container"
                ref={datePickerRef}
              >
                <DateRangePicker
                  onChange={setInvoiceDateRange}
                  value={dateInvoiceRange}
                  className="custom-daterange-picker mobile-daterange-picker"
                  calendarClassName="react-daterange-picker__calendar mobile-calendar-dropdown"
                  rangeDivider="–"
                  format="dd/MM/yyyy"
                  clearIcon={null}
                  calendarProps={{
                    locale: "en-US",
                    showWeekNumbers: false,
                    calendarType: "gregory",
                    showDoubleView: false,
                  }}
                  calendarIcon={
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                        clipRule="evenodd"
                      />
                    </svg>
                  }
                />
              </div>
            </div>
          ),
        };
      default:
        return {
          MainComponent: <MyTransactions dateRange={dateRange} />,
          title: selectedSubNav,
          component: null,
        };
    }
  };

  return (
    <div className="font-interFont w-full bg-[#F6FAFF] min-h-screen flex flex-col overflow-hidden ">
      <div className="flex-grow  overflow-auto">
        <Navbar
          setDropdownOpen={setDropdownOpen}
          dropdownOpen={dropdownOpen}
          dropdownPos={dropdownPos}
          selectedNav={selectedNav}
          setSelectedNav={setSelectedNav}
          setDropdownPos={setDropdownPos}
          otherMenusOpen={otherMenusOpen}
          setOtherMenusOpen={setOtherMenusOpen}
        />
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="w-full bg-gradient-to-r from-[#007FFF] to-[#00C05B] py-4 px-4 overflow-x-auto scrollbar-hide mt-[64px]">
          <div className="flex items-center gap-2 px-3 min-w-min whitespace-nowrap">
            <button
              className={`px-3 py-1.5  rounded-full font-archivo font-semibold text-xs md:text-[14px] ${
                selectedSubNav === "My Transactions"
                  ? "bg-white text-black py-1.5"
                  : "border border-[#FFFFFF70] text-[#FFFFFF70]"
              }`}
              onClick={() => {
                setSelectedSubNav("My Transactions");
                dispatch(fetchRoundPageCategory("My Transactions"));
              }}
            >
              My Transactions
            </button>
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${
                selectedSubNav === "My Winnings"
                  ? "bg-white text-black py-1.5"
                  : "border border-[#FFFFFF70] text-[#FFFFFF70]"
              }`}
              onClick={() => {
                setSelectedSubNav("My Winnings");
                dispatch(fetchRoundPageCategory("My Winnings"));
              }}
            >
              My Winnings
            </button>
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${
                selectedSubNav === "Withdraw"
                  ? "bg-white text-black py-1.5"
                  : "border border-[#FFFFFF70] text-[#FFFFFF70]"
              }`}
              onClick={() => setSelectedSubNav("Withdraw")}
            >
              Withdraw
            </button>
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${
                selectedSubNav === "Token Transfer"
                  ? "bg-white text-black py-1.5"
                  : "border border-[#FFFFFF70] text-[#FFFFFF70]"
              }`}
              onClick={() => setSelectedSubNav("Token Transfer")}
            >
              Token Transfer
            </button>
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${
                selectedSubNav === "My Invoice"
                  ? "bg-white text-black py-1.5"
                  : "border border-[#FFFFFF70] text-[#FFFFFF70]"
              }`}
              onClick={() => setSelectedSubNav("My Invoice")}
            >
              My Invoice
            </button>
          </div>
        </div>
        <div className="flex justify-between items-center px-4 sm:px-8 mt-4">
          <div
            className={`flex ${
              selectedSubNav !== "My Transactions" ? "flex-row" : "flex-col"
            } sm:flex-row justify-between sm:justify-between sm:items-center w-full gap-4 sm:gap-0`}
          >
            <div className="font-archivo text-lg md:text-2xl lg:text-[32px] font-semibold text-left">
              {renderSelectedComponent()?.title}
            </div>
            {renderSelectedComponent()?.component}
          </div>
        </div>

        <div className="mobile-calendar-overlay"></div>

        {renderSelectedComponent().MainComponent}
      </div>
      <>
        <Footer componnent="rules" />
      </>
    </div>
  );
}
